import { render, staticRenderFns } from "./OtherAdd.vue?vue&type=template&id=74fecd73&scoped=true&"
import script from "./OtherAdd.vue?vue&type=script&lang=js&"
export * from "./OtherAdd.vue?vue&type=script&lang=js&"
import style0 from "./OtherAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OtherAdd.vue?vue&type=style&index=1&id=74fecd73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fecd73",
  null
  
)

export default component.exports